export enum PERMISSIONS {
    // DASHBOARDS
    VIEW_DASHBOARDS = 'VIEW_DASHBOARDS',

    // DATASHEETS
    VIEW_DATASHEETS = 'VIEW_DATASHEETS',
    CREATE_DATASHEET = 'CREATE_DATASHEET',
    DELETE_DATASHEET = 'DELETE_DATASHEET',

    // MODULES
    VIEW_MODULES = 'VIEW_MODULES',

    // TESTCASES
    VIEW_TESTCASES = 'VIEW_TESTCASES',

    // TESTPLANS
    VIEW_TESTPLANS = 'VIEW_TESTPLANS',

    // TESTRUNS
    VIEW_TESTRUNS = 'VIEW_TESTRUNS',

    // PROFILES
    VIEW_PROFILES = 'VIEW_PROFILES',

    // BOOKINGS
    VIEW_BOOKINGS = 'VIEW_BOOKINGS',
    ADD_BOOKINGS = 'ADD_BOOKINGS',
    EDIT_BOOKINGS = 'EDIT_BOOKINGS',
    DELETE_BOOKINGS = 'DELETE_BOOKINGS',

    // SCHEMES
    VIEW_SCHEMES = 'VIEW_SCHEMES',
    ADD_SCHEMES = 'ADD_SCHEMES',
    EDIT_SCHEMES = 'EDIT_SCHEMES',
    DELETE_SCHEMES = 'DELETE_SCHEMES',
    DEPLOY_SCHEMES = 'DEPLOY_SCHEMES',

    // STANDS
    VIEW_STANDS = 'VIEW_STANDS',
    EDIT_STANDS = 'EDIT_STANDS',
    DELETE_STANDS = 'DELETE_STANDS',

    // LIBRARY
    VIEW_LIBRARY = 'VIEW_LIBRARY',

    // USER_COUNTER
    EDIT_USER_COUNTER = 'EDIT_USER_COUNTER',

    // DEFECTS
    VIEW_DEFECTS = 'VIEW_DEFECTS',
    ADD_DEFECTS = 'ADD_DEFECTS',
    EDIT_DEFECTS = 'EDIT_DEFECTS',
    DELETE_DEFECTS = 'DELETE_DEFECTS',
}
